export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkServices: "nav-link-services",
  linkPricing: "nav-link-pricing",
  linkHow: "nav-link-how",
  linkFaq: "nav-link-faq",
  cta: "nav-cta-audit",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
  reviewCard: "hero-review-card",
};

export const AUDIT_FORM = {
  root: "audit-form",
  businessName: "audit-input-business-name",
  websiteOrProfile: "audit-input-website",
  email: "audit-input-email",
  phone: "audit-input-phone",
  problem: "audit-input-problem",
  submit: "audit-submit",
  success: "audit-success",
};
